<template>
  <div v-if="visible">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <small class="font-weight-bold">{{ label }}</small>
      <small>{{ currentStep }} / {{ totalSteps }} ({{ percentage }}%)</small>
    </div>

    <b-progress :max="100" class="progress-custom">
      <b-progress-bar :value="percentage">
        {{ percentage }}%
      </b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
  export default {
    name: 'LoadingProgressBar',
    props: {
      totalSteps: {
        type: Number,
        required: true,
      },
      currentStep: {
        type: Number,
        required: true,
      },
      label: {
        type: String,
        default: 'Sending mails...',
      },
      visible: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      percentage() {
        if (!this.totalSteps || this.totalSteps <= 0) return 0;

        const value = Math.round((this.currentStep / this.totalSteps) * 100);
        return Math.min(100, Math.max(0, value));
      },
    },
  };
</script>

<style>
.progress-custom {
  height: 20px;
}
</style>
